import React, { useEffect } from "react";
import { Link } from "react-router-dom";

export const NotFoundPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container-fluid py-5">
      <div className="row px-xl-5 justify-content-center">
        <div className="col-lg-8 text-center py-5">
          <div className="d-flex flex-column align-items-center">
            <h1 className="display-1 text-primary mb-4">404</h1>
            <h2 className="mb-4">Trang không tìm thấy</h2>
            <p className="mb-4">
              Xin lỗi, trang bạn đang tìm kiếm không tồn tại, đã bị xóa hoặc tạm
              thời không có sẵn.
            </p>
            <div className="mb-5">
              <img
                src="/img/404-error.png"
                alt="Page Not Found"
                className="img-fluid"
                style={{ maxHeight: "300px", objectFit: "contain" }}
                onError={(e) => {
                  e.target.style.display = "none";
                }}
              />
            </div>
            <div className="d-flex flex-wrap justify-content-center">
              <Link to="/" className="btn btn-primary m-2 px-4 py-3 ">
                <i className="fa fa-home mr-2"></i>Về trang chủ
              </Link>
              <Link
                to="/san-pham"
                className="btn btn-outline-primary m-2 px-4 py-3"
              >
                <i className="fa fa-shopping-bag mr-2"></i>Mua sắm ngay
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
